const yearPicker = /** @type {HTMLSelectElement|null} */ (
  document.getElementById("customer-sessions-year-picker")
);
const locationPicker = /** @type {HTMLSelectElement|null} */ (
  document.getElementById("customer-sessions-location-picker")
);

if (yearPicker || locationPicker) {
  const noResultsMsg = document.getElementById("customer-sessions-no-results");

  const applyFilters = () => {
    const year = yearPicker ? yearPicker.value : "all-years";
    const loc = locationPicker ? locationPicker.value : "all-locations";
    let visibleCount = 0;

    document.querySelectorAll("[data-session-year]").forEach((el) => {
      const sessionYear = el.getAttribute("data-session-year");
      const sessionLocation = el.getAttribute("data-session-location");

      const matchesYear = year === "all-years" || sessionYear === year;
      const matchesLocation =
        loc === "all-locations" || !sessionLocation || sessionLocation === loc;

      if (matchesYear && matchesLocation) {
        el.classList.remove("hidden");
        visibleCount++;
      } else {
        el.classList.add("hidden");
      }
    });

    if (noResultsMsg) {
      noResultsMsg.classList.toggle("hidden", visibleCount > 0);
    }
  };

  const updateUrl = () => {
    const url = new URL(window.location.href);

    if (yearPicker) {
      if (yearPicker.value === "all-years") {
        url.searchParams.delete("session-year");
      } else {
        url.searchParams.set("session-year", yearPicker.value);
      }
    }

    if (locationPicker) {
      if (locationPicker.value === "all-locations") {
        url.searchParams.delete("session-location");
      } else {
        url.searchParams.set("session-location", locationPicker.value);
      }
    }

    window.history.pushState({}, "", url.href);
  };

  if (yearPicker) {
    yearPicker.addEventListener("change", () => {
      applyFilters();
      updateUrl();
    });
  }

  if (locationPicker) {
    locationPicker.addEventListener("change", () => {
      applyFilters();
      updateUrl();
    });
  }

  // Read URL params on page load
  const urlParams = new URLSearchParams(window.location.search);

  const initialYear = urlParams.get("session-year");
  if (yearPicker && initialYear) {
    yearPicker.value = initialYear;
  }

  const initialLocation = urlParams.get("session-location");
  if (locationPicker && initialLocation) {
    locationPicker.value = initialLocation;
  }

  applyFilters();
}
